import { render } from "./ClickWrapper.vue?vue&type=template&id=08eb7860&ts=true"
import script from "./ClickWrapper.vue?vue&type=script&lang=ts"
export * from "./ClickWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerke-bochum-gut-und-gruen-v2\\wp-content\\themes\\gut-und-gruen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__